(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ec-coupon-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    function initCouponBar() {
      const scrollWrapper = document.querySelector('.ec-coupon-bar__scroll-wrapper');
      if (!scrollWrapper) return;

      let isDown = false;
      let startX;
      let scrollLeft;

      scrollWrapper.addEventListener('mousedown', function(e) {
        isDown = true;
        scrollWrapper.style.cursor = 'grabbing';
        startX = e.pageX - scrollWrapper.offsetLeft;
        scrollLeft = scrollWrapper.scrollLeft;
      });

      scrollWrapper.addEventListener('mouseleave', function() {
        isDown = false;
        scrollWrapper.style.cursor = 'grab';
      });

      scrollWrapper.addEventListener('mouseup', function() {
        isDown = false;
        scrollWrapper.style.cursor = 'grab';
      });

      scrollWrapper.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - scrollWrapper.offsetLeft;
        const walk = (x - startX) * 2;
        scrollWrapper.scrollLeft = scrollLeft - walk;
      });

      scrollWrapper.style.cursor = 'grab';
    }

    initCouponBar();

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
        if (event.target.querySelector('.ec-coupon-bar')) {
          initCouponBar();
        }
      });

      document.addEventListener('shopify:section:select', function(event) {
        if (event.target.querySelector('.ec-coupon-bar')) {
          event.target.scrollIntoView({ behavior: 'smooth' });
        }
      });

      document.addEventListener('shopify:block:select', function(event) {
        if (event.target.classList.contains('ec-coupon-card')) {
          event.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
